import React from 'react'
import DashboardContainer from 'Container/Dashboard'
import DashboardPresentation from 'Presentation/Dashboard'

const DashboardScene = () => {
  return (
    <DashboardContainer>
      <DashboardPresentation />
    </DashboardContainer>
  )
}

export default DashboardScene